import './styles/JobPrice.scss';

import { Grid, Paper, Modal } from '@mui/material';
import type { JobPrice as JobPriceType } from '@thro-types/jobmarket';

import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledInput } from 'app/components/RichList/items/CompanyItem/components/LabeledInput';
import { translations } from 'locales/i18n';

import PriceDetail from './PriceDetail';

interface Props {
  price: JobPriceType;
}

export default function JobPrice({ price }: Props) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Grid item xs={12} md={6} className="job-price" onClick={() => setModalOpen(true)}>
        <Grid
          container
          component={Paper}
          elevation={3}
          className={clsx('job-price__container', {
            'job-price__container--paid': price.price > 0
          })}
        >
          <Grid item xs>
            <LabeledInput label={t(translations.common.name())}>{price.name}</LabeledInput>
          </Grid>
          <Grid item xs>
            <LabeledInput label={t(translations.pages.manageJobmarketSettings.duration())}>
              {price.duration}
            </LabeledInput>
          </Grid>
          <Grid item xs>
            <LabeledInput label={t(translations.pages.manageJobmarketSettings.factor())}>
              {t(translations.pages.manageJobmarketSettings.factors[price.factor]())}
            </LabeledInput>
          </Grid>
          <Grid item xs>
            <LabeledInput
              label={t(translations.pages.manageJobmarketSettings.price())}
              displayAlways
            >
              {price.price}
            </LabeledInput>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        className="type-detail-modal"
        open={modalOpen}
        onClose={(event, reason) => {
          if (reason && reason === 'backdropClick') return;
          setModalOpen(false);
        }}
      >
        <Grid item component={Paper} elevation={5} className="type-detail-modal__body">
          <PriceDetail priceId={price.id} closeHandler={() => setModalOpen(false)} />
        </Grid>
      </Modal>
    </>
  );
}
